export class Configurations {
  public apiUrl: string;

  constructor() {
    this.apiUrl = '';
  }

}
